import React, { useState, useEffect, useRef } from 'react'
import styles from './ScaleCounter.module.css'
import CountUp from 'react-countup'

const ScaleCounter = () => {
  const [startCounting, setStartCounting] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !startCounting) {
          setStartCounting(true)
        }
      },
      { threshold: 0.3 } // Trigger when 30% of the component is visible
    )

    if (containerRef.current) {
      observer.observe(containerRef.current)
    }

    return () => {
      observer.disconnect()
    }
  }, [startCounting])

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.title}>Built to scale</div>
      {startCounting ? (
        <CountUp className={styles.number} end={1000000} separator="," useEasing={true} duration={2} />
      ) : (
        <span className={styles.number}>0</span>
      )}
      <span className={styles.number}>+</span>
      <div className={styles.subtitle}>Links created</div>
    </div>
  )
}

export default ScaleCounter
